'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (op, path, value) {
    if (!isValidJsonPatchOperation(op)) {
        throw new Error('http-client: \'' + op + '\' is not a valid JSON Patch operation. Use one of: add, remove, replace, move, copy, test.');
    }

    if (!path.startsWith('/')) {
        throw new Error('http-client: \'' + path + '\' is not a valid JSON Patch path. A JSON Patch path should start with \'/\'.');
    }

    return { op: op, path: path, value: value };
};

function isValidJsonPatchOperation(op) {
    switch (op) {
        case 'add':
        case 'remove':
        case 'replace':
        case 'move':
        case 'copy':
        case 'test':
            return true;

        default:
    }

    return false;
}